import { isPodscribeEnabled, sendPodscribeEvent } from './client';

const PODSCRIBE_USER_ID = '30a6f746-1c4d-44d2-8996-3528316e9313';
const PODSCRIBE_ADVERTISER = 'firsttableuk';

const hashEmail = async (email: string): Promise<string | undefined> => {
  if (!window.crypto?.subtle) {
    return undefined;
  }

  const bytes = new TextEncoder().encode(email.trim().toLowerCase());
  const digest = await window.crypto.subtle.digest('SHA-256', bytes);
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
};

export const initialisePodscribe = (): void => {
  if (!isPodscribeEnabled() || typeof window.podscribe !== 'function') {
    return;
  }

  window.podscribe('init', {
    user_id: PODSCRIBE_USER_ID,
    advertiser: PODSCRIBE_ADVERTISER,
  });
};

export const podscribeView = (): void => {
  sendPodscribeEvent('view');
};

export const podscribePurchase = async (email?: unknown): Promise<void> => {
  if (!isPodscribeEnabled()) {
    return;
  }

  let hashedEmail: string | undefined;
  if (typeof email === 'string' && email.trim()) {
    try {
      hashedEmail = await hashEmail(email);
    } catch {
      hashedEmail = undefined;
    }
  }

  sendPodscribeEvent('purchase', {
    ...(hashedEmail && { hashed_email: hashedEmail }),
  });
};
